import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { setOpenPopup } from '#action/project/devices-popup';
import DevicePopup from '#component/device/devices-popup/device-popup-project';
import { CountButton, ShowAllButton } from './styles';

const DevicesCountListButton = ({ devicesCount, project, user, devicePopupProps = {} }) => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [openDevicePopup, setOpenDevicePopup] = useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleOpenDevicePopup = () => {
    setOpenDevicePopup(!openDevicePopup);
    dispatch(setOpenPopup(!openDevicePopup, false));
  };

  if (!devicesCount && !openDevicePopup) {
    return null;
  }

  return (
    <>
      {isMobile ?
        <ShowAllButton
          onClick={handleOpenDevicePopup}
        >
          {`Show all (${devicesCount})`}
        </ShowAllButton> :
        <CountButton
          onClick={handleOpenDevicePopup}
          aria-label="Show all"
        >
          {devicesCount}
        </CountButton>}
      {(openDevicePopup) &&
        <DevicePopup
          project={project}
          open={openDevicePopup}
          openedFromCreateForm={false}
          handleOpenPopupExternal={setOpenDevicePopup}
          user={user}
          {...devicePopupProps}
        />}
    </>
  );
};

export default DevicesCountListButton;
